import { render, staticRenderFns } from "./addApp.vue?vue&type=template&id=70ca8c40&scoped=true"
import script from "./addApp.vue?vue&type=script&lang=js"
export * from "./addApp.vue?vue&type=script&lang=js"
import style0 from "./addApp.vue?vue&type=style&index=0&id=70ca8c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca8c40",
  null
  
)

export default component.exports